import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';

import { TimestampAudit } from '@/types/database';

export const getCreatedOnSignature = (userId: string) => ({
  createdOn: {
    timestamp: firebase.firestore.FieldValue.serverTimestamp(),
    userId
  } as TimestampAudit
});

export const getUpdatedOnSignature = (userId: string) => ({
  lastUpdatedOn: {
    timestamp: firebase.firestore.FieldValue.serverTimestamp(),
    userId
  } as TimestampAudit
});
